/**
 * Default fixture for appointment_calendar_settings.
 * Single source of truth for Figma-matching defaults.
 *
 * Used by:
 * - Server seed during org provisioning
 * - Client-side "Reset to Default" action
 */

export type CalendarDefaultView = 'month' | 'week' | 'day' | 'list';
export type WeekStartDay = 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun';
export type ColorAppointmentsBy = 'category' | 'provider' | 'status';

export interface AppointmentCalendarSettingsDefaults {
  filter_category_enabled: boolean;
  filter_status_enabled: boolean;
  filter_provider_enabled: boolean;
  filter_service_enabled: boolean;
  filter_room_enabled: boolean;
  filter_location_enabled: boolean;
  default_view: CalendarDefaultView;
  week_starts_on: WeekStartDay;
  working_hours_start_min: number;
  working_hours_end_min: number;
  slot_interval_min: number;
  color_appointments_by: ColorAppointmentsBy;
}

export const CALENDAR_SETTINGS_DEFAULTS: AppointmentCalendarSettingsDefaults = {
  // Filters
  filter_category_enabled: true,
  filter_status_enabled: true,
  filter_provider_enabled: true,
  filter_service_enabled: true,
  filter_room_enabled: false,
  filter_location_enabled: false,

  // Views
  default_view: 'week',
  week_starts_on: 'mon',

  // Time grid (minutes from 00:00)
  working_hours_start_min: 480, // 08:00
  working_hours_end_min: 1200, // 20:00
  slot_interval_min: 30,

  // Display
  color_appointments_by: 'category',
};
